module.exports = __webpack_public_path__ + "static/img/010.d423023.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-headquarters/010.png
// module id = /EPL
// module chunks = 1